import MODULE from "@/flit2go-web-core/interfaces/moduleConstants";
import {
  CODE_FORM,
  CODE_LIST,
  COMMUNICATIONS,
  COMMUNICATION_FORM,
  DNR,
  PEOPLE_LIST,
  EMPLOYEE_FORM,
  USER_FORM,
  USERS_LIST,
  ORGANIZATIONS_LIST,
  ORGANIZATION_FORM,
} from "@/modules/People/routesInterface";

const menu = {
  code: MODULE.PEOPLE.CODE,
  name: "people",
  label: "common.people",
  link: PEOPLE_LIST,
  children: [],
  createChildren: [],
};

const submenus = [
  {
    code: MODULE.PEOPLE.OWNER_EMPLOYEES,
    icon: "people-1",
    label: "common.personal",
    link: PEOPLE_LIST,
    name: "employees",
    tooltip: "common.personal",
  },
  {
    code: MODULE.PEOPLE.USERS,
    icon: "app-user",
    label: "common.customers",
    link: USERS_LIST,
    name: "users",
    tooltip: "common.customers",
  },
  {
    code: MODULE.PEOPLE.COMMUNICATIONS,
    icon: "megaphone",
    label: "common.communications",
    link: COMMUNICATIONS,
    name: "communications",
    tooltip: "common.communications",
  },
  {
    code: MODULE.PEOPLE.VALIDATION_CODES,
    icon: "validation-code",
    label: "common.validationCodes",
    link: CODE_LIST,
    name: "codes",
    tooltip: "common.validationCodes",
  },
  {
    code: MODULE.PEOPLE.DNR,
    icon: "blocked",
    label: "common.dnr",
    link: `${DNR}/users`,
    name: "dnr",
    tooltip: "common.dnr",
  },
  {
    code: MODULE.PEOPLE.COMPANIES,
    icon: "company",
    label: "companies",
    link: ORGANIZATIONS_LIST,
    name: "companies",
    tooltip: "companies",
  },
];

const submenusCreate = [
  {
    code: MODULE.PEOPLE.OWNER_EMPLOYEES,
    label: "role.employee",
    link: EMPLOYEE_FORM,
    name: "employees",
  },
  {
    code: MODULE.PEOPLE.USERS,
    label: "common.client",
    link: USER_FORM,
    name: "client",
  },
  {
    code: MODULE.PEOPLE.COMMUNICATIONS,
    label: "common.communication",
    link: COMMUNICATION_FORM,
    name: "communication",
  },
  {
    code: MODULE.PEOPLE.VALIDATION_CODES,
    label: "common.validationCodes",
    link: CODE_FORM,
    name: "code",
  },
  {
    code: MODULE.PEOPLE.COMPANIES,
    label: "mobile.common.business",
    link: ORGANIZATION_FORM,
    name: "company",
  },
];

function getMenu(submodules) {
  menu.children = [];
  menu.createChildren = [];
  submodules.forEach((submodule) => {
    const submenuAux = submenus.filter(
      (submenu) => submenu.code === submodule.code
    );
    const submenuCreateAux = submenusCreate.filter(
      (submenu) => submenu.code === submodule.code
    );
    if (submenuAux.length && (submodule.r || submodule.w)) {
      submenuAux.forEach((submenu) => {
        menu.children.push(submenu);
      });
    }
    if (submenuCreateAux.length && submodule.w) {
      submenuCreateAux.forEach((item) => {
        menu.createChildren.push(item);
      });
    }
  });
  return menu;
}

export default { getMenu };
